import type { LocaleCode, LocaleDomain } from "../types";

import { deriveLocaleMetadata } from "../country/derive-locale-metadata";
import { getLocaleRegistry } from "./locale-registry";

/**
 * Returns canonical production site domains from the locale registry (e.g.
 * `homeinstead.com`). Used by `isRegisteredLocaleDomain` for exact-match
 * checks. Does not include dev, local, or Vercel preview hostnames.
 */
function getLocaleDomains(): readonly LocaleDomain[] {
  const localeCodes = Object.keys(getLocaleRegistry()) as LocaleCode[];

  return localeCodes.map((code) => deriveLocaleMetadata(code).domain);
}

export { getLocaleDomains };
